module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_is-object.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_is-object.js
// module chunks = 2